<template>
<div class="quotenewaside">
    <div ref="asideBox" :class="{'smt-aside-fixed':isFixed && !isMinWidth && !isMinHeight}" @resize="handleResize">
        <div class="quotenewaside-item quotenewaside-line">
            <strong class="lt fs-xl f-bold">{{ LANG.pcb_cost }}</strong>
            <span class="gt fs-xl f-bold pd-r-md">{{ LANG.usd }} ${{(valuation && valuation.pcb_total)?$tools.keepDecimal(valuation.pcb_total,2,true):"0.00"}}</span>
        </div>
        <div class="quotenewaside-item" :data-isparamsok="isQuoteParamsOk" :style="showValuation?'':'padding-bottom:0;'" style="margin-bottom:0;">
            <div class="quotenewaside-smt quotenewaside-line pcba-cost-title" :style="showValuation?'':'border-bottom:0;'">
                <strong class="lt fs-xl f-bold">{{ LANG.pcba_cost }}</strong>
                <span class="gt fs-xl f-bold">
                    {{ LANG.usd }} ${{pcbaCost}}
                    <i class="icon fc-dis" style="padding: 0 8px 0 6px;" @click="showFiles"> 
                        {{showValuation?"&#xe892;":"&#xe87e;"}}                    
                    </i>
                </span>
            </div>
            <div class="quotenewaside-box" v-show="showValuation">
                <div v-if="quoteLoading" class="quotenewaside-loading">
                    <img :src="$imgList.loading_0" alt="">
                </div>
                <ul class="quotenewaside-fileshow" v-if="!valuation || !isQuoteParamsOk">
                    <li class="_item" :data-params="aside_param" :data-ok="pcbParamsOk">                     
                        <i class="icon vlm mg-r-sm" :class="{'c-success':aside_param.gerber_file_id && pcbParamsOk,'c-ready':!aside_param.gerber_file_id||!pcbParamsOk}"> &#xe8c3;</i> <span class="vlm _text"> Step 1 : Upload Gerber File </span>
                        <p v-if="aside_param.gerber_file_id && !pcbParamsOk" class="fill-quantity-tip">{{ LANG.fill_quantity_tip }}</p>
                    </li>
                    <li class="_item">
                        <i class="icon vlm mg-r-sm" :class="{'c-success':aside_param.other_file_id,'c-ready':!aside_param.other_file_id}">&#xe8c3;</i> <span class="vlm _text">   Step 2 : Upload Centroid File </span>
                    </li>
                    <li class="_item">
                        <i class="icon vlm mg-r-sm" :class="{'c-success':smt_params.bom_file_id,'c-ready':!smt_params.bom_file_id}">&#xe8c3;</i> <span class="vlm _text">  Step 3 : Upload BOM File </span>
                    </li>
                </ul>
                <div v-if="!valuation" class="upload-tip">
                        {{LANG.pcba_quote_tip}}
                </div>
                <template v-if="valuation && valuation.list && valuation.list.assembly && isQuoteParamsOk">
                    <ul class="pd-tb-sm">
                        <li class="quotenewaside-line">
                            <span class="lt fc-gnr">
                                {{ LANG.setup_cost }}
                            </span>
                            <span class="gt">
                                <span :class="{'delete-line':this.isSmtActivity}">
                                    ${{setupCost}}
                                </span>
                                <template v-if="this.isSmtActivity">
                                    &nbsp;&nbsp;$0.00
                                </template>
                            </span>
                        </li>
                        <li class="quotenewaside-line">
                            <span class="lt fc-gnr">
                                {{ LANG.material_cost }}
                            </span>
                            <span class="gt">
                            ${{materialCost}}
                            </span>
                        </li>
                        <li class="quotenewaside-line">
                            <span class="lt fc-gnr">
                                {{ LANG.assembly_cost }}
                            </span>
                            <span class="gt">
                                <span :class="{'delete-line':this.isSmtActivity}">
                                    ${{assemblyCost}}
                                </span>
                                <template v-if="this.isSmtActivity">
                                    &nbsp;&nbsp;$0.00
                                </template>
                            </span>
                        </li>
                        <li class="quotenewaside-line">
                            <span class="lt fc-gnr">
                                {{ LANG.component_cost }}
                            </span>
                            <span class="gt">
                                ${{componentCost}}
                            </span>
                        </li>
                        <li class="quotenewaside-line">
                            <span class="lt fc-gnr">
                                {{ LANG.operation_fee }}
                            </span>
                            <span class="gt">
                                <span :class="{'delete-line':this.isSmtActivity}">
                                    ${{operationFee}}
                                </span>
                                <template v-if="this.isSmtActivity">
                                    &nbsp;&nbsp;$0.00
                                </template>
                            </span>
                        </li>
                    </ul>

                    <!-- 阶梯价格 -->
                    <ladder-price class="smt-ladder-price"></ladder-price>
                
                    <div v-if="0" class="quotenewaside-total">
                        <div class="quotenewaside-line pd-tb-sm">
                            <span class="lt f-bold">{{ LANG.sub_total }}</span>
                            <span class="gt fc-tips">USD 
                                <span :class="{'delete-line':this.isSmtActivity, 'f-bold': true}">${{valuation.total?$tools.keepDecimal(valuation.total - valuation.total_freight,2,true):"0.00"}}
                                </span>
                            </span>
                        </div>
                        <div v-if="isSmtActivity" class="quotenewaside-line pd-tb-sm">
                            <span class="lt f-bold">  </span>
                            <span class="gt f-bold fc-tips" style="font-size:24px;">USD ${{smtActivityTotal?smtActivityTotal:"0.00"}}</span>
                        </div>
                        <div v-if="0" class="quotenewaside-line pd-tb-sm">
                            <span class="lt fc-gnr">{{ LANG.production_time }}</span>
                            <span class="gt">{{ valuation.delivery_date_number }} {{ LANG.working_days }}</span>
                        </div>
                        <div class="quotenewaside-submit pd-b-sm">
                            <button class="np-btn mg-t-md np-btn-main np-btn-lg" @click="addtocart">
                                <i class="icon">&#xe62a;</i>
                                {{ LANG.add_to_cart }}                      
                            </button>
                        </div>

                        <!-- BOM 存在人工报价时，展示该提示语 -->
                        <p v-show="bomManualQuoteNumber" class="bom-manual-quotayion-tip">Price does not include components that require manual quoting. Please Add to Cart and we will update the quotation within 1 working day.</p>            
                    </div>
                </template>
            </div>
        </div>
        <div v-if="!valuation || !isQuoteParamsOk" class="btn-box">
            <div class="btn">
                {{LANG.calculate}}
            </div>
        </div>

        <!-- 加购&总价按钮不收起 -->
        <div v-if="valuation && valuation.list && valuation.list.assembly && isQuoteParamsOk" class="quotenewaside-total">
            <div class="quotenewaside-line pd-tb-sm">
                <span class="lt f-bold">{{ LANG.sub_total }}</span>
                <span class="gt fc-tips">USD 
                    <span :class="{'delete-line':this.isSmtActivity, 'f-bold': true}">${{valuation.total?$tools.keepDecimal(valuation.total - valuation.total_freight,2,true):"0.00"}}
                    </span>
                </span>
            </div>
            <div v-if="isSmtActivity" class="quotenewaside-line pd-tb-sm">
                <span class="lt f-bold">  </span>
                <span class="gt f-bold fc-tips" style="font-size:24px;">USD ${{smtActivityTotal?smtActivityTotal:"0.00"}}</span>
            </div>
            <div v-if="0" class="quotenewaside-line pd-tb-sm">
                <span class="lt fc-gnr">{{ LANG.production_time }}</span>
                <span class="gt">{{ valuation.delivery_date_number }} {{ LANG.working_days }}</span>
            </div>
            <div class="quotenewaside-submit pd-b-sm">
                <button class="np-btn mg-t-md np-btn-main np-btn-lg" @click="addtocart">
                    <i class="icon">&#xe62a;</i>
                    {{ LANG.add_to_cart }}                      
                </button>
            </div>

            <!-- BOM 存在人工报价时，展示该提示语 -->
            <p v-show="bomManualQuoteNumber" class="bom-manual-quotayion-tip">Price does not include components that require manual quoting. Please Add to Cart and we will update the quotation within 1 working day.</p>            
        </div>

        <!-- 下单须知 -->
		<p class="order-instruction">
			<a @click="clickOrderInstruction">{{ LANG.order_instructions }}</a>
		</p>
    </div>
    <div v-if="(!valuation || !isQuoteParamsOk) && ads.length " class="quote-aside_ad mg-t-md">
		<!-- 廣告 -->
		<template v-for="(v,i) in ads">
		<a class="quote-aside_adimg mg-b-md" v-if="v.ad_fixed" :key = "i" 
			:target="v.ad_fixed.target"
			:href="v.ad_fixed.link !== ''?v.ad_fixed.link:false"
		>
			<img :width="v.ad_fixed.width" :height="v.ad_fixed.height" :src="v.ad_fixed.banner" :alt="v.ad_fixed.desc">
		</a>			
		</template>		
	</div>
    <login-win v-model="loginWinShow" @loginsuccess = "loginsuccess"></login-win>

    

    <!-- 下单须知弹窗 -->
	<confirm-modal :options="orderOptions" v-if="orderVisible" :show="orderVisible" @closeConfirm="orderVisible=false">
		<div slot="content" class="order-instruction-content">
			<p>{{ LANG.order_instructions_call }}：</p>
			<p>{{ LANG.order_instructions_tips }}</p>
			<h3>{{ LANG.order_instructions_tip1 }}</h3>
			<p>{{ LANG.order_instructions_tip1a }}</p>
			<p>{{ LANG.order_instructions_tip1b }}</p>
			<p>{{ LANG.order_instructions_tip1c }}</p>
			<p>{{ LANG.order_instructions_tip1d }}</p>
			<p>{{ LANG.order_instructions_tip1e }}</p>
			<p>{{ LANG.order_instructions_tip1f }}</p>
			<p>{{ LANG.order_instructions_tip1g }}</p>
			<p>{{ LANG.order_instructions_tip1h }}</p>
			<p>{{ LANG.order_instructions_tip1i }}</p>
			<p>{{ LANG.order_instructions_tip1j }}</p>
			<h3>{{ LANG.order_instructions_tip2 }}</h3>
			<p class="f-bold">{{ LANG.order_instructions_tip2_1 }}</p>
			<p>{{ LANG.order_instructions_tip2_1a }}</p>
			<p>{{ LANG.order_instructions_tip2_1b }}</p>
			<p>{{ LANG.order_instructions_tip2_1c }}</p>
			<p>{{ LANG.order_instructions_tip2_1d }}</p>
			<p class="f-bold">{{ LANG.order_instructions_tip2_2 }}</p>
			<p>{{ LANG.order_instructions_tip2_2a }}</p>
			<p>{{ LANG.order_instructions_tip2_2b }}</p>
			<p>{{ LANG.order_instructions_tip2_2c }}</p>
			<p>{{ LANG.order_instructions_tip2_2d }}</p>
			<p>{{ LANG.order_instructions_tip2_2e }}</p>
			<p>{{ LANG.order_instructions_tip2_2f }}</p>
			<p class="f-bold">{{ LANG.order_instructions_tip2_3 }}</p>
			<p>{{ LANG.order_instructions_tip2_3a }}</p>
			<p>{{ LANG.order_instructions_tip2_3b }}</p>
			<p>{{ LANG.order_instructions_tip2_3c }}</p>
			<p>{{ LANG.order_instructions_tip2_3d }}</p>
			<p>{{ LANG.order_instructions_tip2_3e }}</p>
			<p class="f-bold">{{ LANG.order_instructions_tip2_4 }}</p>
			<p>{{ LANG.order_instructions_tip2_4a }}</p>
			<p>{{ LANG.order_instructions_tip2_4b }}</p>
			<p class="f-bold">{{ LANG.order_instructions_tip2_5 }}</p>
			<p>{{ LANG.order_instructions_tip2_5a }}</p>
			<p>{{ LANG.order_instructions_tip2_5b }}</p>
			<p class="f-bold">{{ LANG.order_instructions_tip2_6 }}</p>
			<p>{{ LANG.order_instructions_tip2_6a }}</p>
			<p>{{ LANG.order_instructions_tip2_6b }}</p>
			<p>{{ LANG.order_instructions_tip2_6c }}</p>
			<p>{{ LANG.order_instructions_tip2_6d }}</p>
			<p>{{ LANG.order_instructions_tip2_6e }}</p>
			<p>{{ LANG.order_instructions_tip2_6f }}</p>
			<p class="f-bold">{{ LANG.order_instructions_tip2_7 }}</p>
			<p>{{ LANG.order_instructions_tip2_7a }}</p>
			<p>{{ LANG.order_instructions_tip2_7b }}</p>
			<h3>{{ LANG.order_instructions_tip3 }}</h3>
			<p>{{ LANG.order_instructions_tip3a }}</p>
			<p>{{ LANG.order_instructions_tip3b }}</p>
			<p>{{ LANG.order_instructions_tip3b1 }}</p>
			<p>{{ LANG.order_instructions_tip3b2 }}</p>
			<p>{{ LANG.order_instructions_tip3c }}</p>
			<p>{{ LANG.order_instructions_tip3d }}</p>
			<p>{{ LANG.order_instructions_tip3e }}</p>
			<p>{{ LANG.order_instructions_tip3f }}</p>
			<h3>{{ LANG.order_instructions_tip4 }}</h3>
			<p>{{ LANG.order_instructions_tip4a }}</p>
			<p>{{ LANG.order_instructions_tip4b }}</p>
			<p>{{ LANG.order_instructions_tip4c }}</p>
			<p>{{ LANG.order_instructions_tip4d }}</p>
			<p>{{ LANG.order_instructions_tip4e }}</p>
			<p>{{ LANG.order_instructions_tip_note }}</p>
		</div>
	</confirm-modal>
</div>
</template>
<script>
import loginWin from '@/components/public/loginwin.vue'
import ladderPrice from '@/components/quote/quoteaside/ladder_price.vue'
export default {
    data(){
        return {
            queteLoading:false,
            showValuation:true,
            loginWinShow:false,
            calcArea:0,
            bomManualQuoteNumber: 0, // bom手动报价数量
            gaCount:0, // 谷歌ga推送次数
            isMinHeight: false,
            orderOptions: {
                area:["817px", '650px'],
                skin:"quote-size-conver_alert",
                title: '下单须知', 
                btns: []
            },
            orderVisible: false,
        }
    },
    mounted(){
        this.$bus.$on('pcbCalcArea', (calcArea) => {
			this.calcArea = calcArea
		})
        this.$bus.$on('bomManualQuoteNumberEvent', (bomManualQuoteNumber) => {
            this.bomManualQuoteNumber = bomManualQuoteNumber
        })
        this.getAdinfo()

        window.addEventListener('resize', this.handleResize)
        const resizeObserver = new ResizeObserver((entries)=>{
            this.handleResize(entries[0].contentRect)
        })
        resizeObserver.observe(this.$refs.asideBox)

        this.$once("hook:beforeDestroy",()=>{
            resizeObserver.disconnect()
             window.removeEventListener('resize', this.handleResize)
        })
    },
    computed:{
        quoteLoading(){
			return this.$store.state.quote.quoteLoading;
		},
        valuation(){
			return this.$store.getters.getQuoteValuation;
		},
        relation(){
			return this.$store.state.quote.relation;
		},
        smt_params(){
            return this.$store.state.quote.smt_params;
        },
        aside_param(){
			return this.$store.state.quote.aside_param;
		},
        isLogin(){
			return this.$store.getters.isLogin;
		},
        isQuoteParamsOk(){
            let pcbParamsOk = this.pcbParamsOk;
            let smtParamsOk = this.$store.getters.isQuoteParamsOk("smt");           
            if(pcbParamsOk && smtParamsOk) return true;
            return  false;
        },
        pcbParamsOk(){
            return this.$store.getters.isQuoteParamsOk("pcb");
        },
		params(){
			return this.$store.getters.getQuoteParams;
		},
        // smt活动
        isSmtActivity(){
            const flag=Number(this.valuation?.pcba_assembly_five_pcs_free)===1
            this.$store.commit('setIsSmtActivity',flag)
            return flag
        },
        // smt活动减免后的钱
        smtActivityTotal(){
            if(!this.valuation){
				return null
			}
            const smtFreeTotal=this.valuation?.list?.assembly?.set_up_fee_sum + this.valuation?.list?.assembly?.assembly_cost+ this.valuation?.list?.assembly?.operation_fee
            return this.$tools.keepDecimal(this.valuation?.total - this.valuation?.total_freight - smtFreeTotal,2,true)
        },
        ads(){		
			let adsCode = this.getAdsCode(),ads = [];
            if(adsCode){
				if(adsCode[0]){
					let a1 = this.$store.getters.getAds(adsCode[0]);
					if(a1) {ads.push(a1);}
                    else{
                        // 禁用A07广告，A08不展示
                        return []
                    }					
				}
				
				if(adsCode[1]){
					let a2 = this.$store.getters.getAds(adsCode[1]);
					if(a2) ads.push(a2);
				}
			}
			return ads;
		},
        pcbaCost(){
            if(!this.isQuoteParamsOk){
                return 0
            }
            const smtFreeTotal=this.valuation?.list?.assembly?.set_up_fee_sum + this.valuation?.list?.assembly?.assembly_cost+ this.valuation?.list?.assembly?.operation_fee || 0
            if(this.isSmtActivity){
                return this.$tools.keepDecimal(Number(this.valuation?.assembly_total) + Number(this.valuation?.bom_total - Number(smtFreeTotal)),2,true)
            }
            else {
                return this.$tools.keepDecimal(Number(this.valuation?.assembly_total) + Number(this.valuation?.bom_total),2,true) || '0.00'
            }
        },
        setupCost(){
            return this.$tools.keepDecimal(this.valuation?.list?.assembly?.set_up_fee_sum,2,true) || '0.00'
        },
        materialCost(){
            return this.$tools.keepDecimal(this.valuation?.list?.assembly?.material_cost_fee_sum,2,true) || '0.00'
        },
        assemblyCost(){
            return this.$tools.keepDecimal(this.valuation?.list?.assembly?.assembly_cost,2,true) || '0.00'
        },
        componentCost(){
            return this.$tools.keepDecimal(this.valuation?.list?.assembly?.component_cost,2,true) || '0.00'
        },
        operationFee(){
            return this.$tools.keepDecimal(this.valuation?.list?.assembly?.operation_fee,2,true) || '0.00'
        },
        subTotal(){
            return this.$tools.keepDecimal(this.valuation?.total - this.valuation?.total_freight,2,true) || '0.00'
        },
        isFixed(){
			return this.$store.state.isFixed
		},
        isMinWidth(){
            return this.$store.state.isMinWidth
        }
    },
    methods:{
        loginsuccess(){
            //登錄成功 重新計價
			this.countCalc();
			this.$store.dispatch("getCommonData");
        },
        addtocart(){
            if(!this.isLogin){
                return this.loginWinShow = true;
            }            
            if(!this.isQuoteParamsOk)     return this.$alert.msg(this.LANG.params_is_not_complete);
            
            if(this.params.blayer > 3 && this.params.blayer <= 20 && this.params.pbnum > 4){
				this.$alert.msg(this.LANG.pbnum_limit_tip)
				return false
			}
            
            if(!this.params.period_format){
                let _this = this;
					//ul mark 提示
					return this.$alert.confirm({
						area:["350px"],
						title: this.LANG.tips,
						content:this.LANG.ul_mark_tips,
						btns:[{
								text: this.LANG.ok,
								callBack(e){
                                   _this.$store.commit("setsmtQuoteOn",0);
									//跳转到选取区域，不加入购物车\
                                    setTimeout(() => {
                                        let ulmarkOffset = _this.$store.getters.getElementOffset("quote_ulmark");
                                        window.scrollTo(0,ulmarkOffset.top || 0);
                                        e.close();    
                                    }, 50);									
								}
							},
							{
								text:this.LANG["don't need"],
								callBack(e){									
									_this.submit();
									e.close();
								}
						}]
					})
				}else{
                    this.submit();
                }
        },
        submit(){
            this.$store.dispatch("addtoCart").then((res)=>{				
				if(res && res.code !== 200){
					this.$alert.msg(res.msg);					
				}
			});
        },
        showFiles(){
            this.showValuation = !this.showValuation;            
        },
        countCalc(){
			//計價方法
			/*
			1,面積大於0 説明 必填參數已齊全，可以傳遞參數
			*/		
            if(this.isQuoteParamsOk){
                this.$store.dispatch("calcQuoteValuation");
            }			
		},
        // 获取广告编码
        getAdsCode(){
			let ads = [],A1,A2;
            A1 = "A07";
            A2 = "A08";
            ads.push(A1)
            ads.push(A2)
			
			return ads;
		},
        // 获取广告内容
        getAdinfo(){
			let ads = this.getAdsCode();
				if(ads.length){
					this.$store.dispatch("getAdinfo",{banner_code:ads.join(",")});
				}			
		},
        handleResize(rect){
            this.$tools.debounce(()=>{
                const winHeight = window.innerHeight
                const elHeight = rect.height || this.$refs.asideBox.clientHeight
                const fiexdHeight = 192
                // console.log((winHeight - fiexdHeight),elHeight)
                if((winHeight - fiexdHeight) < elHeight){
                    this.isMinHeight = true
                }
                else{
                    this.isMinHeight = false
                }
            },"handleResize",1000)();  
		},
        clickOrderInstruction() {
			this.orderOptions.title = this.LANG.order_instructions
			this.orderVisible = true
		}
    },
    watch:{
        /* 与smt文件调用计价方法重复 不用 20230823 */
        // isQuoteParamsOk(v){
        //     if(v) this.countCalc();
        // },
        valuation(o){
			if(!o) return;
			// 谷歌ga4事件跟踪
			try {
				if(!window){
					return false
				}
                if(this.gaCount===0){
                    this.gaCount++
                    window.dataLayer.push({event:'pcbacostdisplayed'})
                }
			} catch (error) {
				console.error(error)
			}
		}
    },
    components: {					
		"login-win": loginWin,
        'ladder-price': ladderPrice,
		
	}
}
</script>
<style lang="scss">
.quotenewaside {
    width: 30%;
    float: right;
    margin-bottom: 20px;
    //quotenewaside-body
    &-body{
        box-sizing: border-box; 
        // background: #fff;
        // padding: 20px;
        position: relative;   
    }
    //quotenewaside-line
    &-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 20px;
    }
    .pcba-cost-title {
        padding-right: 0;
    }
    &-item {
        background: #fff;
        margin-bottom: 12px;
        padding-top: 12px ;
        padding-bottom: 12px ;
        position: relative;
        &:last-child{
            padding-bottom: 0;
        }        
    }

    &-loading {
        position: absolute;
        background-color: rgba($color: #000000, $alpha: 0.5);
        left: 0;
        top:0;
        right: 0;
        bottom: 0;
        z-index: 10;

        img{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
        }
    }
    &-submit {
        padding: 0 20px;
        .np-btn {
            width: 100%;
            border-radius: 2px;
        }

    }
    &-smt {
        border-bottom: 1px solid #E6E6E6;
        padding-bottom: 12px;
        padding-top: 0px;
        .icon {
            cursor: pointer;
        }
    }
    &-total {
        border-top: 1px solid #e6e6e6;
        padding: 12px 0;
        background: #FFF;
    }

    .quotenewaside-box{
        position: relative;

        .fill-quantity-tip{
            position: absolute;
            top: 40px;
            left: 38px;
            color: #c00;
            white-space: nowrap;
        }
    }

    &-fileshow {
        text-align: center;
        padding: 20px 0;
        ._item {
            padding: 8px 0;
            text-align: left;
            width: 70%;
            margin: 0 auto;
            font-size: 16px;
            position: relative;
            
            .icon {               
                font-size: 24px;
                width: 24px;
            }

            &:nth-child(-n+2){
                margin-bottom: 20px;
                 &::after{
                content: '';
                height: 30px;
                width: 1px;
                border-left: 1px dashed #c6c6c6;
                position: absolute;
                left: 11px;
                top: 36px;
            }
            }

           
        }
    }
    &-aniloading {
        width: 20px;
        height: 20px;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translateY(-50%);
        .circle {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #c00;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            animation: rotate 1.2s ease-in-out infinite;
        }
        .circle:nth-child(1) {
            animation-delay: 0s;
        }
        .circle:nth-child(2) {
            animation-delay: 0.15s;
        }
        .circle:nth-child(3) {
            animation-delay: 0.3s;
        }
        .circle:nth-child(4) {
            animation-delay: 0.45s;
        }
        .circle:nth-child(5) {
            animation-delay: 0.6s;
        }
        .circle:nth-child(6) {
            animation-delay: 0.75s;
        }
        .circle:nth-child(7) {
            animation-delay: 0.9s;
        }
        .circle:nth-child(8) {
            animation-delay: 1.05s;
        }
        @keyframes rotate {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
        }
        .circle:nth-child(1) {
            animation-delay: 0s;
            left:-68%;
            top: 24%;            
        }
        .circle:nth-child(2) {
            animation-delay: 0.15s;
            left:21%;
            top:-70%; 
        }
        .circle:nth-child(3) {
            animation-delay: 0.3s;
            left:70%;
            top:-35%;            
        }
        .circle:nth-child(4) {
            animation-delay: 0.45s;
            left: -45%;
            top: -47%;           
        }
        .circle:nth-child(5) {
            animation-delay: 0.6s;
            left: 70%;
            top: 30%; 
        }
        .circle:nth-child(6) {
            animation-delay: 0.75s;
            left: 30%;
            top: 70%;
        }
        .circle:nth-child(7) {
            animation-delay: 0.9s;
            left: -29.29%;
            top: 70.71%;          
        }
        .circle:nth-child(8) {
            animation-delay: 1.05s;
            left: -70.71%;
            top: 29.29%; 
        }
    }

    .order-instruction {
		text-align: right;
		padding-right: 20px;
		padding-bottom: 10px;
        background: #fff;
		a {
			cursor: pointer;
			color: $color-purple;
			text-decoration: underline;
		}
	}
	.order-instruction-content {
		h3 {
			font-weight: 700;
			padding: 10px 0;
			font-size: 16px;
		}
		p {
			line-height: 1.8;
		}
	}
    
}

.bom-manual-quotayion-tip {
    margin: 10px 20px 0;
    padding: 10px;
    color: #B8802C;
    background: #fff7eb;
    border-radius: 2px;
    font-size: 12px;
    line-height: 20px;
}

.delete-line{
    text-decoration: line-through;
}

.c-ready{
    color: #c6c6c6;
}

.c-success{
    color: #15b223;
}

.upload-tip{
    // width: 100%;
    margin: 0 20px;
    background: #fff7fa;
    padding: 10px;
    margin-bottom: 20px;
}

.roate{
    transform: rotate(180deg);
}

.btn-box{
    display: flex;
    justify-content: center;
    background: #FFF;
    // margin-bottom: 12px;
    padding: 0 20px;
    padding-bottom: 20px;
}

.btn{
    width: 100%;
    height: 48px;
    line-height: 48px;
    border-radius: 5px;
    font-size: 16px;
    text-align: center;
    cursor: not-allowed;
    background: #f7bbbb;
    color: #fff;
    
    // margin-top: 20px;
}

.smt-ladder-price{
    margin: 0 20px;
    border-top: 1px solid #e6e6e6;
}

.p-lr-0{
    padding-left: 0;
    padding-right: 0;
}
.smt-aside-fixed{
	width: 360px;
    background-color: #f2f2f2;
	position: fixed !important;
	left: 50%;
	top: calc(48px + 60px);
	transform: translateX(-50%);
	margin-left: 420px;
	z-index: 100;
	box-sizing: border-box;
}
</style>